import debugFactory from "debug";
import { AuthenticationEvents } from "@teaming/common-enums";
import socketMachineFactory from "./socketMachine";

export default function ioSocketFactory( { config: { apiSocketEndpoint, }, authService, } ) {
	const socketMachine = socketMachineFactory( { authService, apiSocketEndpoint, } );

	// We may not be authenticated by the time connect is called on the socketMachine
	// so this enables us to not care about the order of operations...the websocket
	// connection will proceed once the authService says we're logged in.
	authService.on( AuthenticationEvents.LOGIN, () => socketMachine.connect() );

	const debug = debugFactory( "teaming:common-io:fsm:socket-machine" );
	socketMachine.on( "*", debug );
	socketMachine.on( "transitioned", () => {
		debug( `FSM state: ${ socketMachine.compositeState() }` );
	} );
	// Leaving here for diagnostics reference
	// window.__SOCKETMACHINE = socketMachine;
	// If you want to see the "composite" state of the parent (socketMachine)
	// and child (messageMachine) while in connected state, you can run this
	// in the browser console (assuming above lines are also un-commented):
	// __SOCKETMACHINE.compositeState() // -> "connected.ready", for example

	return {
		// stores (or store helper modules) should call this to add listeners
		// for when SocketMessageTypes arrive via the WS connection
		addSocketMessageListener: ( ...args ) => {
			return socketMachine.on( ...args );
		},

		connectToSocket: async () => {
			debug( "connecting websockets" );
			socketMachine.connect();
		},

		socketMachine,
	};
}
